module.exports = __webpack_public_path__ + "img/17.9d553a67.png";